export default function getArrayItem(array: any[], pos: number) {
  return array[pos];
}
